import Group from './group';
import InternalRadio from './radio';
import Button from './radioButton';
export { RadioChangeEvent, RadioChangeEventTarget, RadioGroupButtonStyle, RadioGroupContextProps, RadioGroupOptionType, RadioGroupProps, RadioProps, } from './interface';
export { Button, Group };
const Radio = InternalRadio;
Radio.Button = Button;
Radio.Group = Group;
Radio.__BWD_RADIO = true;
export default Radio;
